<template>
	<div
		class="flex-col container-tabs h-disp-flex nav-menu-mobile"
		:class="{ 'is-disabled': isDisabled }"
	>
		<div
			v-if="isDisabled"
			class="empty"
		/>
		<div
			v-if="!isDisabled"
			class="tab-content"
		>
			<div
				v-if="selectedKey"
				:key="`tab-details-${selectedKey}`"
				class="tabs-details"
			>
				<slot :name="`tab-details-${selectedKey}`" />
			</div>
		</div>
		<div class="flex-col tabs h-disp-flex">
			<ul
				class="h-disp-flex"
				data-qa="mobile-tabs"
				:class="{ hidden: menuHidden }"
			>
				<li
					v-for="tab in tabs"
					:key="`tab-${tab.key}`"
					class="flex-grow justify-center items-center h-disp-flex"
					:class="{ 'is-active': tab.key === selectedKey }"
					@click="isDisabled ? undefined : selectTab(tab.key)"
				>
					<div class="spacer">
						<Icon
							:icon-name="tab.icon"
							color-class="sc-white"
							size="lg"
						/>
					</div>
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
import Icon from '@components/Icon';
import bus from '@videotools/js/events';

export default {
	name:       'NavigationMenuMobile',
	components: { Icon },
	props:      {
		tabs: {
			type:    Array,
			default: () => [],
		},
		isDisabled: {
			type: Boolean,
		},
		activeTab: {
			type: String,
		},
	},
	data() {
		return {
			selectedKey: null,
			menuHidden:  false,
		};
	},
	watch: {
		tabs(newTabs) {
			// If the selected tab doesn't exist in the new list of tabs redirect to first
			const alreadySelectedTab = newTabs.find((tab) => tab.key === this.selectedKey);
			if (!alreadySelectedTab) this.updateTab(newTabs[0]?.key);
		},
		activeTab(value) {
			if (value !== this.selectedKey) this.updateTab(value);
		},
	},
	mounted() {
		if (!this.activeTab) this.updateTab(this.tabs[0].key);
		else this.selectedKey = this.activeTab;

		bus.subscribe('tabs:hide-menu', this.hideMenu);
		bus.subscribe('tabs:show-menu', this.showMenu);
	},
	destroyed() {
		bus.unsubscribe('tabs:hide-menu', this.hideMenu);
		bus.unsubscribe('tabs:show-menu', this.showMenu);
	},
	methods: {
		hideMenu() {
			this.menuHidden = true;
		},
		showMenu() {
			this.menuHidden = false;
		},
		selectTab(tabKey) {
			this.updateTab(tabKey);
		},
		updateTab(tabKey) {
			this.selectedKey = tabKey;
			this.$emit('tab-change', tabKey);
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.container-tabs {
	position: relative;
	height: 100%;
}

.empty {
	position: absolute;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background: var(--color-black);
	opacity: 0.25;
	z-index: 1000000;
}

.tabs {
	flex: 0 1 auto;
	border-top: 1px solid var(--color-grey-800);
}

.tabs li {
	box-sizing: border-box;
	list-style-type: none;
	display: inline-flex;
	height: 56px;
	background-color: var(--color-shadow-grey);
	cursor: pointer;
	color: var(--color-soft-white);
}

.tabs li .spacer {
	border-bottom: 1px solid transparent;
}

.is-disabled .tabs li {
	background-color: var(--color-grey-600);
	cursor: default;
}

.tabs li.is-active {
	cursor: default;
	background-color: var(--color-grey-900);
	border-top: 1px solid var(--color-hype-yellow);
	color: var(--color-hype-yellow);
}

.tab-content {
	flex-grow: 1;
	overflow-y: auto;
}

.tabs-details {
	height: 100%;
}
</style>
